import React, { RefObject } from "react";
import { Plan, PlanDetailsPageSection } from "../../../@types";
import { PlanDetailSection } from "../components";
import { shouldSuppressPlanBenefits, useTranslate } from "../../../helpers";
import { Premiums } from "./Premiums";
import { Deductibles } from "./Deductibles";
import { OopcMaximum } from "./OopcMaximum";
import { ContactInformation } from "./ContactInformation";
import { Alert } from "@cmsgov/ds-medicare-gov";

const OverviewSection: React.FunctionComponent<{
  plan: Plan;
  sectionRef: RefObject<HTMLDivElement>;
}> = ({ plan, sectionRef }) => {
  const t = useTranslate();
  return (
    <PlanDetailSection
      id={PlanDetailsPageSection.OVERVIEW}
      title={t("plan_details.overview")}
      sectionRef={sectionRef}
    >
      {shouldSuppressPlanBenefits(plan.redactions) ? (
        <div className="PlanDetailsSection__alert-container">
          <Alert
            variation="warn"
            heading={t("suppressed_plan_benefit.alert.title")}
            hideIcon
          >
            {t("suppressed_plan_benefit.alert.content")}
          </Alert>
        </div>
      ) : (
        <>
          <Premiums plan={plan} />
          <Deductibles plan={plan} />
          <OopcMaximum plan={plan} />
        </>
      )}
      <ContactInformation plan={plan} />
    </PlanDetailSection>
  );
};

export { OverviewSection };
